import { zodResolver } from "@hookform/resolvers/zod";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../components/ErrorMessage";

const FaqAddModal = ({ schema, onCreate }) => {
  const modalCloseIconButton = useRef(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    onCreate(data);
    modalCloseIconButton.current.click();
  };

  const handleCloseModal = () => {
    reset();
  };

  return (
    <div className="pb-4">
      <div className="text-right">
        <button
          className="add-btn"
          type="button"
          data-toggle="modal"
          data-target="#staticBackdrop"
        >
          Add FAQ +
        </button>
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Add FAQ
              </h5>
              <button
                ref={modalCloseIconButton}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body p-0">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="custom-card mb-0">
                  <div className="form__div-container">
                    <div className="form__div">
                      <input
                        type="text"
                        className="form__input"
                        {...register("questionEn")}
                      />
                      <label htmlFor="" className="form__label">
                        Question
                      </label>
                    </div>
                    <ErrorMessage message={errors?.questionEn?.message} />
                  </div>
                  <div className="mb-3">
                    <div className="form__div--textarea">
                      <textarea
                        className="form__textarea"
                        rows="7"
                        {...register("answerEn")}
                      />
                      <label htmlFor="" className="textarea-form__label">
                        Answer
                      </label>
                    </div>
                    <ErrorMessage message={errors?.answerEn?.message} />
                  </div>
                  <div className="text-right">
                    <button type="submit" className="save-btn mt-3">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqAddModal;
